import { supabase } from './supabase';

export type InvoiceEventName = 'submitted' | 'approved' | 'rejected' | 'paid';

/**
 * Tell the people involved (admins, or the host) what just happened to an invoice.
 * The invoice action has already succeeded, so a failed notification is only
 * logged: it must never make the action look like it failed.
 */
export async function notifyInvoiceEvent(invoiceId: string, event: InvoiceEventName): Promise<void> {
  try {
    const { error } = await supabase.functions.invoke('notify-invoice-event', { body: { invoice_id: invoiceId, event } });
    if (error) console.error('notify-invoice-event failed:', error);
  } catch (e) {
    console.error('notify-invoice-event failed:', e);
  }
}
